import { Slide } from '@features/powerpoint';
import { divider, xAxis, yAxis } from './axes';
import { controlLine, exposedLine } from './trend-lines';
import { periodMarker } from './period-marker';
import { legend } from './legend';

export const chart = {
  texts: periodMarker,
  shapes: [xAxis, divider, yAxis],
  images: [legend, controlLine, exposedLine],
} as const satisfies Slide;
